// extracted by mini-css-extract-plugin
export var content = "_e1-3";
export var list = "_e1-4";
export var settingsContent = "_e1-7";
export var settingsPanel = "_e1-8";
export var state = "_e1-6";
export var triggerBadge = "_e1-2";
export var triggerButton = "_e1-1";
export var triggerShell = "_e1-0";
export var unreadDot = "_e1-5";